import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';

import { ApContentService } from '@ap/content';
import { ApScrollService } from '@ap/scroll';

import { DigicodeHerstelNotification } from '../../klant/digicode-herstel/digicode-herstel.model';
import { MijnLoginNavigation } from '../mijn-login.navigation';
import { MijnLoginService } from '../mijn-login.service';

import content from './digicode-herstel.wrapper.content.json';

/**
 * @ngdoc component
 * @name DigicodeHerstelWrapperComponent
 * @module DigicodeHerstelWrapperModule
 */
@Component({
    selector: 'credentials',
    templateUrl: './digicode-herstel.wrapper.component.html',
    standalone: false
})
export class DigicodeHerstelWrapperComponent implements OnInit {
    public notification: DigicodeHerstelNotification;
    public changeUsername: boolean;
    public currentUsername: string;
    public isHuismapLogin: boolean;

    public constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly contentService: ApContentService,
        private readonly loginService: MijnLoginService,
        private readonly mijnLoginNavigation: MijnLoginNavigation,
        private readonly scrollService: ApScrollService
    ) {}

    public ngOnInit(): void {
        if (this.loginService.getSignCredentials() === undefined) {
            this.mijnLoginNavigation.toLogin();
            return;
        }
        this.currentUsername = this.loginService.getSignCredentials().username;
        this.changeUsername = this.loginService.isChangeUsername();

        this.contentService.addContentItems(content);
        this.activatedRoute.queryParams.pipe(take(1)).subscribe((params) => {
            this.isHuismapLogin = params.huismap != null;
        });
    }

    public getTitle(): string {
        if (this.changeUsername) {
            return this.contentService.get('mijn.login.digicode.herstel.wrapper.gebruikersnaam.wachtwoord.title');
        }
        return this.contentService.get('mijn.login.digicode.herstel.wrapper.wachtwoord.title');
    }

    public toLogin(notification: DigicodeHerstelNotification): void {
        if (notification) {
            this.loginService.setNotificationMessage(notification);
        } else {
            this.loginService.setNotificationMessage(null);
        }
        this.mijnLoginNavigation.toLogin();
    }

    public setNotification(notification: DigicodeHerstelNotification): void {
        this.notification = notification;
        this.scrollService.scrollTo('notification');
    }
}
